// 🎬🗂 VM 한쪽 패널 꼬리표·제목 글 — 순수 함수(의존 0). 장표 층(`Overlay169SlideLayer`)은 정밀 편집기 앱에서도 컴파일되는데,
//   그 앱은 `@/…` 별칭을 자기 vendor 로 돌린다 → 설계도 템플릿 묶음(story-template)을 끌어오면 빌드가 깨진다(10-07 #6056 CI).
//   그래서 화면 쪽이 쓰는 글 다듬기만 여기 두고, 작업물 판정(`vm-side-panel.ts`)은 따로 둔다.

/** 설계도 다리(`msb-blueprint`)가 새 VM 앵커 clipPlan 에 찍는 표식 값(`look`) — 이 표식이 있는 작업물은 그림 바탕 VM 도 한쪽 패널이다(`vm-side-panel.ts`). */
export const VM_PANEL_LOOK = "side" as const;

/** 꼬리표 글 상한(글자) — 넘으면 꼬리표를 달지 않는다(말줄임 대신 생략 · 한 줄 작은 꼬리표가 목적). */
export const VM_PANEL_TAG_MAX = 14;

/** 장면 이름 구분자 — «예방대책 02 — 지지대 설치»·«사고 개요: 벽체 무너짐» 꼴(앞뒤 공백이 있는 대시·세로줄·가운뎃점·쌍점). */
const SCENE_NAME_SEP = /\s+[—–\-|·:]\s+|:\s+/;

/** 장면 이름의 앞부분을 꼬리표로 — «예방대책 02 — 지지대 설치» → «예방대책 02». 구분자가 없으면 이름 전체. 상한을 넘거나 비면 undefined. */
export function vmPanelTag(sceneName: unknown): string | undefined {
  if (typeof sceneName !== "string") return undefined;
  const head = sceneName.split(SCENE_NAME_SEP)[0]?.trim() ?? "";
  return head && [...head].length <= VM_PANEL_TAG_MAX ? head : undefined;
}

const plain = (s: string): string => s.replace(/[\s\p{P}\p{S}]+/gu, "");

/** 장면 이름 조각 — [전체, 첫 구분자 앞, 첫 구분자 뒤](구분자가 없으면 [전체]). 앞 조각이 곧 꼬리표 글이다. */
export function sceneNamePieces(sceneName: unknown): string[] {
  if (typeof sceneName !== "string" || !sceneName.trim()) return [];
  const whole = sceneName.trim();
  const m = SCENE_NAME_SEP.exec(whole);
  return (m ? [whole, whole.slice(0, m.index), whole.slice(m.index + m[0].length)] : [whole]).map((x) => x.trim()).filter(Boolean);
}

/** 글이 장면 이름(전체·앞 조각=꼬리표·뒤 조각)을 되풀이하는가 — 공백·문장부호는 무시하고 «같을 때만»(포함은 아님).
 *  설계도 fallback 체크리스트가 첫 항목에 장면 이름을 한 번 더 싣던 것(«예방대책 02 — …» 아래 «예방대책 02»)을 거른다. */
export function isSceneNameEcho(text: unknown, sceneName: unknown): boolean {
  if (typeof text !== "string") return false;
  const t = plain(text);
  return !!t && sceneNamePieces(sceneName).some((piece) => plain(piece) === t);
}

/** 장표 제목이 꼬리표를 되풀이하면 화면에서만 덜어낸다(저장 데이터는 그대로).
 *  · 제목 = 꼬리표(공백·문장부호만 다름) → 꼬리표를 뗀다(제목이 같은 말을 이미 크게 한다).
 *  · 제목이 «꼬리표 + 구분자 + 나머지» → 제목은 나머지만(«예방대책 02 — 지지대 설치» 아래 꼬리표 «예방대책 02»). */
export function vmPanelTitle(title: unknown, tag: string | undefined): { title: string | undefined; tag: string | undefined } {
  const t = typeof title === "string" ? title : undefined;
  if (!t || !tag) return { title: t, tag };
  if (plain(t) === plain(tag)) return { title: t, tag: undefined };
  if (t.startsWith(tag)) {
    const rest = t.slice(tag.length).replace(/^\s*(?:[—–\-|·:]\s+|:\s*)/, "");
    if (rest !== t.slice(tag.length) && rest.trim()) return { title: rest.trim(), tag };
  }
  return { title: t, tag };
}
